import { createContext, useContext, useState, useEffect } from 'react';

const CompanyConfigContext = createContext();

export const useCompanyConfig = () => {
  const context = useContext(CompanyConfigContext);
  if (!context) {
    throw new Error('useCompanyConfig debe usarse dentro de CompanyConfigProvider');
  }
  return context;
};

export const CompanyConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  // Cargar configuración desde localStorage al inicializar
  useEffect(() => {
    const savedConfig = localStorage.getItem('companyConfig');
    if (savedConfig) {
      try {
        setConfig(JSON.parse(savedConfig));
      } catch (error) {
        console.error('Error parsing company config from localStorage:', error);
        localStorage.removeItem('companyConfig');
      }
    }
    setLoading(false);
  }, []);

  // Guardar configuración (llamado desde AuthContext al login)
  const setCompanyConfig = (newConfig) => {
    setConfig(newConfig);
    if (newConfig) {
      localStorage.setItem('companyConfig', JSON.stringify(newConfig));
    } else {
      localStorage.removeItem('companyConfig');
    }
  };

  // Limpiar configuración (llamado al logout)
  const clearCompanyConfig = () => {
    setConfig(null);
    localStorage.removeItem('companyConfig');
  };

  // Obtener logo según configuración
  const getLogo = () => {
    if (!config) return 'falcon'; // default
    return config.logo || 'falcon';
  };

  // Obtener tema según configuración
  const getTheme = () => {
    if (!config) return 'default-theme';
    return config.theme || 'default-theme';
  };

  // Obtener colores según configuración
  const getColors = () => {
    if (!config) return {
      primary: '#059669',
      secondary: '#0d9488',
      accent: '#06b6d4'
    };
    return config.colors || {
      primary: '#059669',
      secondary: '#0d9488',
      accent: '#06b6d4'
    };
  };

  const value = {
    config,
    loading,
    setCompanyConfig,
    clearCompanyConfig,
    getLogo,
    getTheme,
    getColors,
    // Helpers
    isHerreraHavas: config?.code === 'HERRERA_HAVAS',
    isQuraflow: config?.code === 'QURAFLOW',
    companyName: config?.name || 'Galaxy Metrics',
    companyCode: config?.code || 'QURAFLOW'
  };

  return (
    <CompanyConfigContext.Provider value={value}>
      {children}
    </CompanyConfigContext.Provider>
  );
}; 